<template>
    <div id="main">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <span>
                    <h1 class="title">
                        {{ $t("vincular-tabela-preco") }}
                    </h1>
                </span>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t("cancelar") }}
                </button>
                <button
                    v-if="!asstabprecoprodutoIntegracao"
                    class="save-btn"
                    type="button"
                    @click="save"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-6-desktop">
                    <vss-select
                        :id="generateId(1)"
                        ref="idTabelaPreco"
                        :options="tabelasPreco"
                        v-model="tabelaPrecoSelecionada"
                        searchable
                        required
                        title="tabela-preco"
                        :invalid="isNull(tabelaPrecoSelecionada)"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="info-tabela-preco-pai"
                        tooltipSize="is-large"
                        @search="debouncedOnSearch"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(29)"
                        ref="tarjaitemcatalogoInput"
                        :options="tarjaitemcatalogoSelect"
                        v-model="asstabprecoproduto.tarjaitemcatalogo"
                        title="tabelapreco-tarja"
                        :possuiImagem="true"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="tooltip-atp-grupocomissao"
                        tooltipSize="is-small"
                        msg="porcentagem-invalida"
                        :invalid="!asstabprecoproduto.tarjaitemcatalogo"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(30)"
                        ref="grupocomissaoInput"
                        :options="grupocomissaoSelect"
                        v-model="grupocomissaoSelected"
                        title="grupocomissao"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="tooltip-atp-grupocomissao"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-6-desktop">
                    <v-money
                        :id="generateId(2)"
                        ref="valorunitarioInput"
                        title="tabelapreco-valorunitario"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.valorunitario"
                        :max="9999999"
                        required
                        tooltipLabel="tooltip-atp-valor-unitario"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(3)"
                        ref="valor1Input"
                        title="valor"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.valor1"
                        :max="9999999"
                        required
                        tooltipLabel="tooltip-atp-valor"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(4)"
                        ref="valorminimoInput"
                        title="tabelapreco-valorminimo"
                        msg="msg-valor-minimo"
                        v-model="asstabprecoproduto.valorminimo"
                        :max="9999999"
                        required
                        :invalid="
                            asstabprecoproduto.valorminimo >
                            asstabprecoproduto.valor1
                        "
                        tooltipLabel="tooltip-atp-valor-minimo"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(5)"
                        ref="valormaximoInput"
                        title="tabelapreco-valormaximo"
                        msg="msg-valor-maximo"
                        v-model="asstabprecoproduto.valormaximo"
                        :max="9999999"
                        required
                        :invalid="
                            asstabprecoproduto.valormaximo <
                            asstabprecoproduto.valor1
                        "
                        tooltipLabel="tooltip-atp-valor-maximo"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(6)"
                        ref="descmaximo1Input"
                        title="tabelapreco-descmaximo"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.descmaximo1"
                        :max="100"
                        required
                        tooltipLabel="tooltip-atp-desconto-maximo"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(7)"
                        ref="custoprodutoInput"
                        title="tabelapreco-custo"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.custoproduto"
                        :max="9999999"
                        required
                        tooltipLabel="tooltip-atp-custo"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(8)"
                        ref="margemitemInput"
                        title="tabelapreco-margemitem"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.margemitem"
                        required
                        :max="100"
                        tooltipLabel="tooltip-atp-margem-item"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(9)"
                        ref="qtdeminimavendaInput"
                        title="tabelapreco-qtdeminimavenda"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.qtdeminimavenda"
                        :max="9999999"
                        tooltipLabel="tooltip-atp-qtde-minven"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <verified-date-picker
                        :id="generateId(10)"
                        ref="datamaximaInput"
                        v-model="asstabprecoproduto.datamaxima"
                        placeholder="selecione-uma-data"
                        title="tabelapreco-datavalidade"
                        msg="msg-campo-obrigatorio"
                        :subtractDateByDate="$moment().toDate()"
                        :addDateYears="2"
                        :years-range="[-3, 3]"
                        :invalid="isNull(asstabprecoproduto.datamaxima)"
                        required
                        :inForm="true"
                        tooltipLabel="tooltip-atp-data-maxima"
                        tooltipSize="is-small"
                        :showClean="false"
                        :position="'is-bottom-right'"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(11)"
                        ref="encargoInput"
                        title="tabelapreco-encargo"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.encargo"
                        :max="100"
                        tooltipLabel="tooltip-atp-encargo"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(12)"
                        ref="comissaoInput"
                        title="tabelapreco-comissao"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.comissao"
                        :max="100"
                        tooltipLabel="tooltip-atp-comissao"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(13)"
                        ref="percentualdiarioInput"
                        title="tabelapreco-percentualdiario"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.percentualdiario"
                        :disabled="isNull(asstabprecoproduto.datamaxima)"
                        :max="100"
                        tooltipLabel="tooltip-atp-perc-diario"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(14)"
                        ref="percentualdiariojuroInput"
                        title="tabelapreco-percentualdiariojuro"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.percentualdiariojuro"
                        :disabled="isNull(asstabprecoproduto.datamaxima)"
                        :max="100"
                        tooltipLabel="tooltip-atp-perc-diariojuro"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-input
                        :id="generateId(15)"
                        ref="percflexsomaInput"
                        title="tabelapreco-percflexsoma"
                        placeholder="placeholder-preencha"
                        msg="porcentagem-invalida"
                        v-model="asstabprecoproduto.percflexsoma"
                        tooltipLabel="tooltip-atp-perc-flexsoma"
                        tooltipSize="is-large"
                        :onBlurFunction="validatePercflexsoma"
                        :maxlength="6"
                        validchars="0123456789.-"
                        :invalid="invalidPercflexsoma"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(39)"
                        ref="percdescvalortotalitemflexInput"
                        title="tab-preco-percdescvalortotalitemflex"
                        placeholder="placeholder-preencha"
                        v-model="asstabprecoproduto.percDescValorTotalItemFlex"
                        :max="100"
                        tooltipLabel="tooltip-atp-percdescvalortotalitemflex"
                        suffix="%"
                        tooltip="is-small"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(16)"
                        ref="minimoprodutoqtdeInput"
                        title="tabelapreco-minimoprodutoqtde"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.minimoprodutoqtde"
                        :max="9999999"
                        tooltipLabel="tooltip-atp-min-prodqtd"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(17)"
                        ref="maximoprodutoqtdeInput"
                        title="tabelapreco-maximoprodutoqtde"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.maximoprodutoqtde"
                        :max="9999999"
                        tooltipLabel="tooltip-atp-max-prodqtd"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(18)"
                        ref="descprodutoqtdeInput"
                        title="tabelapreco-descprodutoqtde"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.descprodutoqtde"
                        :max="9999999"
                        tooltipLabel="tooltip-atp-desc-qntd"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(19)"
                        ref="icmsInput"
                        title="tabelapreco-ICMS"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.icms"
                        :max="100"
                        tooltipLabel="tooltip-atp-icms"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(20)"
                        ref="pmcInput"
                        title="tabelapreco-PMC"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="asstabprecoproduto.pmc"
                        :max="9999999"
                        tooltipLabel="tooltip-atp-pmc"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(30)"
                        ref="desctriplomaximo1Input"
                        title="tabelapreco-descontotriplo1"
                        placeholder="placeholder-preencha"
                        v-model="asstabprecoproduto.desctriplomaximo1"
                        :max="100"
                        tooltipLabel="tooltip-atp-desc-triplo"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(31)"
                        ref="desctriplomaximo2Input"
                        title="tabelapreco-descontotriplo2"
                        placeholder="placeholder-preencha"
                        v-model="asstabprecoproduto.desctriplomaximo2"
                        :max="100"
                        tooltipLabel="tooltip-atp-desc-triplo"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money
                        :id="generateId(32)"
                        ref="desctriplomaximo3Input"
                        title="tabelapreco-descontotriplo3"
                        placeholder="placeholder-preencha"
                        v-model="asstabprecoproduto.desctriplomaximo3"
                        :max="100"
                        tooltipLabel="tooltip-atp-desc-triplo"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money 
                        :id="generateId(54)"
                        ref="percentualMargemMinimaInput"
                        title="tabelapreco-percentual-margem-minima"
                        suffix="%"
                        v-model="asstabprecoproduto.percentualMargemMinima"
                        tooltipLabel="tooltip-percentual-margem-minima"
                        tooltip="is-small"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money 
                        :id="generateId(24)"
                        ref="porcDebitaFlexInput"
                        title="tab-preco-porcdebitaflex"
                        suffix="%"
                        v-model="asstabprecoproduto.porcDebitaFlex"
                        tooltipPosition="is-left"
                        tooltipLabel="tooltip-atp-porcdebitaflex"
                        tooltipSize="is-small"
                        tooltipMultilined
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <v-money 
                        :id="generateId(33)"
                        ref="porcCreditaFlexInput"
                        title="tab-preco-porccreditaflex"
                        suffix="%"
                        v-model="asstabprecoproduto.porcCreditaFlex"
                        tooltipPosition="is-left"
                        tooltipLabel="tooltip-atp-porccreditaflex"
                        tooltipSize="is-small"
                        tooltipMultilined
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <vss-select
                        :id="generateId(21)"
                        ref="liberaalteracaoInput"
                        :options="selectSimNao"
                        v-model="asstabprecoproduto.liberaalteracao"
                        required
                        title="tabelapreco-liberaalteracao"
                        :invalid="!asstabprecoproduto.liberaalteracao"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="tooltip-atp-libera-alteracao"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <vss-select
                        :id="generateId(22)"
                        ref="ofertaInput"
                        :options="selectSimNao"
                        v-model="asstabprecoproduto.oferta"
                        title="tabelapreco-emoferta"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="tooltip-atp-oferta"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <vss-select
                        :id="generateId(23)"
                        ref="descflexvlrmenorInput"
                        :options="selectSimNao"
                        v-model="asstabprecoproduto.descflexvlrmenor"
                        title="tabelapreco-descflexvlrmenor"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="tooltip-atp-acrsc-flexmaior"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <vss-select
                        :id="generateId(24)"
                        ref="acresflexvlrmaiorInput"
                        :options="selectSimNao"
                        v-model="asstabprecoproduto.acresflexvlrmaior"
                        title="tabelapreco-acresflexvlrmaior"
                        :tooltipMultilined="true"
                        tooltipPosition="is-left"
                        tooltipLabel="tooltip-atp-desc-flexmenor"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <vss-select
                        :id="generateId(25)"
                        ref="ignoraregraprazoInput"
                        :options="selectSimNao"
                        v-model="asstabprecoproduto.ignoraregraprazo"
                        title="tabelapreco-ignoraregraprazo"
                        :tooltipMultilined="true"
                        tooltipLabel="tooltip-atp-ignora-regra"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <vss-select
                        :id="generateId(26)"
                        ref="permitetrocaInput"
                        :options="selectSimNao"
                        v-model="asstabprecoproduto.permitetroca"
                        title="tabelapreco-permitetroca"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="tooltip-atp-permite-troca"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <vss-select
                        :id="generateId(27)"
                        ref="permitebonificacaoInput"
                        :options="selectSimNao"
                        v-model="asstabprecoproduto.permitebonificacao"
                        title="tabelapreco-permitebonificacao"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="tooltip-atp-permite-bonif"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-4-desktop is-6-tablet">
                    <vss-select
                        :id="generateId(28)"
                        ref="permitebonifnavendaInput"
                        :options="selectSimNao"
                        v-model="asstabprecoproduto.permitebonifnavenda"
                        title="tabelapreco-permitebonifnavenda"
                        :tooltipMultilined="true"
                        tooltipPosition="is-left"
                        tooltipLabel="tooltip-atp-permite-bonifven"
                        tooltipSize="is-small"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GrupoComissaoService from "@/services/vendas/GrupoComissaoService"
import VenProdutoService from "@/services/vendas/produto/VenProdutoService";
import TabPrecoService from "@/services/vendas/tabpreco/TabPrecoService";
import PrecoValidation from "@/services/validations/vendas/produto/PrecoValidation";
import Message from "@/models/Message";

export default {
    props: {
        idasstabprecoproduto: {
            type: Number,
            default: 0,
        },
        idproduto: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            asstabprecoprodutoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("ASSTABPRECOPRODUTO"),
            service: new VenProdutoService(this.$http, this.$router),
            tabprecoService: new TabPrecoService(this.$http, this.$router),
            grupocomissaoService: new GrupoComissaoService(this.$http, this.$router),
            validation: new PrecoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            asstabprecoproduto: {
                idtabpreco: 0,
                idproduto: 0,
                idasstabprecoproduto: null,
                valor1: 0,
                valormaximo: 0,
                valorminimo: 0,
                valorunitario: 0,
                descmaximo1: 0,
                icms: 0,
                liberaalteracao: { id: 0, label: this.$t("nao") },
                custoproduto: 0,
                margemitem: 0,
                oferta: { id: 0, label: this.$t("nao") },
                pmc: 0,
                encargo: 0,
                comissao: 0,
                valorfabrica: 0,
                porcDebitaFlex: 0,
                porcCreditaFlex: 0,
                descflexvlrmenor: { id: 0, label: this.$t("nao") },
                acresflexvlrmaior: { id: 0, label: this.$t("nao") },
                ignoraregraprazo: { id: 0, label: this.$t("nao") },
                permitetroca: { id: 0, label: this.$t("nao") },
                permitebonificacao: { id: 0, label: this.$t("nao") },
                permitebonifnavenda: { id: 0, label: this.$t("nao") },
                qtdeminimavenda: 0,
                datamaxima: null,
                percentualdiario: 0,
                percentualdiariojuro: 0,
                percflexsoma: 0,
                minimoprodutoqtde: 0,
                maximoprodutoqtde: 0,
                descprodutoqtde: 0,
                desctriplomaximo1: 0,
                desctriplomaximo2: 0,
                desctriplomaximo3: 0,
                tarjaitemcatalogo: "",
                replicapda: null,
                percDescValorTotalItemFlex: 0,
                percentualMargemMinima: 0,
                // Id de associação com grupo de comissao
                idgrupocomissao: null,
            },
            date: new Date(this.$moment().add(1, "days")),
            empresas: [],
            isUpdate: false,
            tabelasPreco: [],
            tabelaPrecoSelecionada: null,
            tarjaitemcatalogoSelect:  [],
            selectSimNao: [
                { id: 0, label: this.$t("nao") },
                { id: 1, label: this.$t("sim") },
            ],
            invalidPercflexsoma: false,
            invalidPercMargemitem: false,
            invalidPercdiario: false,
            invalidPercdiariojuro: false,
            invalidIcms: false,
            search: "",
            debouncedOnSearch: null,
            // Associação com grupo de comissao
            grupocomissaoSelected: null,
            grupocomissaoSelect: [],
            precoSelected: null,
        };
    },
    created() {
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.isUpdate = this.idasstabprecoproduto != 0;

        this.carregarDados();
    },
    methods: {
        onSearch(value) {
            this.search = this.removeAcentos(value);
            this.search = this.search.replaceAll(/[./-]/g, "");
            this.loadTabPreco();
        },
        carregarDados() {
            if(this.isUpdate){
                this.carregarAssTabPrecoProduto();
                return;
            }else {
                this.loadTarjaItem();
                this.loadEmpresas();
                this.loadTabPreco();
                this.loadGrupoComissao();
            }
        },
        carregarAssTabPrecoProduto(){
            this.service
                .getByIdAssTabPrecoProduto(this.idasstabprecoproduto)
                .then((body) => {
                    this.precoSelected = body
                })
                .then(()=>{
                    this.processAssTabProduto();
                })
                .catch((e) => {
                    console.error("Erro ao carregar tabela de preço: " + e);
                })
                .finally(() =>{
                    this.loadTarjaItem();
                    this.loadEmpresas();
                    this.loadTabPreco();
                    this.loadGrupoComissao();
                })
        },
        processAssTabProduto(){
            this.asstabprecoproduto = this.precoSelected;
            this.asstabprecoproduto.idtabpreco = this.precoSelected.tabpreco.idtabpreco;
            this.asstabprecoproduto.idproduto = this.idproduto;
            this.asstabprecoproduto.datamaxima = this.$moment(this.precoSelected.datamaxima).toDate();

            if(this.precoSelected.grupoComissao) {
                this.asstabprecoproduto.idgrupocomissao = this.precoSelected.grupoComissao.id
                this.grupocomissaoSelected = {
                    id: this.precoSelected.grupoComissao.id,
                    label: this.precoSelected.grupoComissao.descricao
                }
            }
            // @84565 - SELECTS
            // PRIMEIRA LINHA SELECTS
            this.asstabprecoproduto.liberaalteracao = this.selectSimNao.filter((e) => {
                return this.precoSelected.liberaalteracao == e.id;
            })[0];
            this.asstabprecoproduto.oferta = this.selectSimNao.filter((e) => {
                return this.precoSelected.oferta == e.id;
            })[0];
            this.asstabprecoproduto.descflexvlrmenor = this.selectSimNao.filter((e) => {
                return this.precoSelected.descflexvlrmenor == e.id;
            })[0];
            this.asstabprecoproduto.acresflexvlrmaior = this.selectSimNao.filter((e) => {
                return this.precoSelected.acresflexvlrmaior == e.id;
            })[0];
            // SEGUNDA LINHA SELECTS
            this.asstabprecoproduto.ignoraregraprazo = this.selectSimNao.filter((e) => {
                return this.precoSelected.ignoraregraprazo == e.id;
            })[0];
            this.asstabprecoproduto.permitetroca = this.selectSimNao.filter((e) => {
                return this.precoSelected.permitetroca == e.id;
            })[0];
            this.asstabprecoproduto.permitebonificacao = this.selectSimNao.filter((e) => {
                return this.precoSelected.permitebonificacao == e.id;
            })[0];
            this.asstabprecoproduto.permitebonifnavenda = this.selectSimNao.filter((e) => {
                return this.precoSelected.permitebonifnavenda == e.id;
            })[0];
        },
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: e.id });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: e.id });
                });
            }
        },
        loadTarjaItem(){
            this.service
                .loadTarjaItem()
                .then((body) => {
                    return body.content.map((r, i) => {
                        return {
                            id: i,
                            label: r.nome,
                            nome: r.nome,
                            imagem: r.imagem,
                        };
                    });
                })
                .then((r) => {
                    this.tarjaitemcatalogoSelect = r;
                    this.tarjaitemcatalogoSelect.unshift({
                        id: 0,
                        nome: null,
                        imagem: null,
                        label: this.$t("nenhum")
                    })

                    const isprecoSelected = this.precoSelected && this.precoSelected.mediaTag;
                    let tmpList = this.tarjaitemcatalogoSelect.filter((obj) => {
                        return obj.imagem == (
                            isprecoSelected ? this.precoSelected.mediaTag.url : null
                        )
                    });
                    this.asstabprecoproduto.tarjaitemcatalogo = tmpList[0];
                    if (isprecoSelected) {
                        this.asstabprecoproduto.tarjaitemcatalogo.mediaTag = this.precoSelected.mediaTag
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar tabelas de preço: " + e);
                })
        },
        loadTabPreco() {
            let empresaSelecionada = "0, ";
            for (let e of this.empresas) {
                empresaSelecionada += `${e.id}, `;
            }
            empresaSelecionada = empresaSelecionada.slice(0, -2);
            let idtabpreco = (this.isUpdate) ? this.precoSelected.idtabpreco : 0;

            this.service
                .findAllComboPreco(
                    this.idproduto,
                    empresaSelecionada,
                    idtabpreco,
                    this.search
                )
                .then((body) => {
                    return body.content.map((r) => {
                        return {
                            id: r.tabpreco.idtabpreco,
                            label: `${r.tabpreco.idtabprecoerp} - ${r.tabpreco.descricao}`,
                        };
                    });
                })
                .then((r) => {
                    this.tabelasPreco = [];
                    for (let tabpreco of r) {
                        this.tabelasPreco.push(tabpreco);
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar tabelas de preço: " + e);
                })
                .finally(() => {
                    if (this.isUpdate) {
                        this.tabelaPrecoSelecionada = this.tabelasPreco.filter(
                            (e) => e.id == this.asstabprecoproduto.idtabpreco
                        )[0];
                    } else {
                        this.tabelaPrecoSelecionada = this.tabelasPreco[0];
                    }
                });
        },
        loadGrupoComissao() {
            this.grupocomissaoService
                .findAllCombo()
                .then(this.mapGrupoComissao)
                .then((data) => {
                    this.grupocomissaoSelect = data;
                })
                .catch((e) => {
                    console.error("Erro ao carregar grupo de comissao: " + e);
                })
                .finally( () => {
                    if(this.grupocomissaoSelected != null) {
                        let temp = this.grupocomissaoSelect.find(f => f.id = this.grupocomissaoSelected.id);
                        if(!temp.id) {
                            this.grupocomissaoSelect.unshift(this.grupocomissaoSelected);
                        }
                    }
                });
        },
        // Mapeia o grupocomissao em um objeto
        mapGrupoComissao({ content }) {
            return content.map((m) => {
                return {
                    id: m.id,
                    label: m.descricao,
                }
            });
        },

        validatePercflexsoma() {
            this.invalidPercflexsoma = !this.validatePorcentagem(
                this.asstabprecoproduto.percflexsoma,
                true
            );
        },
        generateId(numberId) {
            return this.$route.name + "-asslicenca-" + numberId;
        },
        save() {
            this.isLoading = true;

            if (
                this.validation.validate(
                    this.asstabprecoproduto,
                    this.$refs,
                    this.tabelaPrecoSelecionada,
                    this.grupocomissaoSelected,
                ) &&
                !this.invalidPercflexsoma
            ) {
                let asstabprecoproduto = Object.assign(
                    {},
                    this.asstabprecoproduto
                );
                asstabprecoproduto = this.mapTosave(asstabprecoproduto);
                asstabprecoproduto.datamaxima =
                    this.asstabprecoproduto.datamaxima != null
                        ? this.$moment(this.asstabprecoproduto.datamaxima)
                              .add(1, "days")
                              .format("YYYY-MM-DD")
                        : this.$moment(this.date).format("YYYY-MM-DD");

                asstabprecoproduto.idtabpreco = this.tabelaPrecoSelecionada.id;
                asstabprecoproduto.liberaalteracao =
                    asstabprecoproduto.liberaalteracao.id;
                asstabprecoproduto.oferta = asstabprecoproduto.oferta
                    ? asstabprecoproduto.oferta.id
                    : 0;
                asstabprecoproduto.descflexvlrmenor =
                    asstabprecoproduto.descflexvlrmenor
                        ? asstabprecoproduto.descflexvlrmenor.id
                        : 0;
                asstabprecoproduto.acresflexvlrmaior =
                    asstabprecoproduto.acresflexvlrmaior
                        ? asstabprecoproduto.acresflexvlrmaior.id
                        : 0;
                asstabprecoproduto.ignoraregraprazo =
                    asstabprecoproduto.ignoraregraprazo
                        ? asstabprecoproduto.ignoraregraprazo.id
                        : 0;
                asstabprecoproduto.permitetroca =
                    asstabprecoproduto.permitetroca
                        ? asstabprecoproduto.permitetroca.id
                        : 0;
                asstabprecoproduto.permitebonificacao =
                    asstabprecoproduto.permitebonificacao
                        ? asstabprecoproduto.permitebonificacao.id
                        : 0;
                asstabprecoproduto.permitebonifnavenda =
                    asstabprecoproduto.permitebonifnavenda
                        ? asstabprecoproduto.permitebonifnavenda.id
                        : 0;
                asstabprecoproduto.idproduto = this.idproduto;

                asstabprecoproduto.idgrupocomissao = this.grupocomissaoSelected != null
                    ? this.grupocomissaoSelected.id : 0;
                
                asstabprecoproduto.tarjaitemcatalogo = this.asstabprecoproduto.tarjaitemcatalogo.nome
                
                //mediatag
                const tarjaitemcatalogotmp = this.asstabprecoproduto.tarjaitemcatalogo
                const mediaTag = {
                    idmedia: tarjaitemcatalogotmp.mediaTag ? tarjaitemcatalogotmp.mediaTag.idmedia : 0,
                    conteudo: tarjaitemcatalogotmp.nome,
                    url: tarjaitemcatalogotmp.imagem
                }
                
                asstabprecoproduto.mediaTag = mediaTag

                this.isSaving = true;
                this.service
                    .salvarAssTabPrecoProdutoComTag(asstabprecoproduto)
                    .then((value) => {
                        if (value.message == null) {
                            let msg =
                                this.asstabprecoproduto.idasstabprecoproduto !=
                                null
                                    ? "msg-edit-asstabpreco"
                                    : "msg-save-asstabpreco";
                            this.msgs.push(new Message("success", msg, true));
                            setTimeout(() => {
                                this.$emit("fecharModal", true);
                            }, 500);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        console.error("Erro ao salvar: " + e);
                        this.msgs.push(
                            new Message("error", "msg-erro-salvar", true)
                        );
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
                this.isLoading = false;
            }
        },
        onFecharModal() {
            this.$emit("fecharModal", true);
        },
    },
};
</script>


<style lang="scss" scoped>
#main {
    width: 100%;
    padding: 20px 20px !important;
    background-color: $sovis-white;
    margin: auto;
}
</style>
